import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, MediumText, PaperBlock, SmallGrayText } from '@guryou/html-components';
import OnboardWorkingHours from '../components/OnboardWorkingHours';

const WorkingHoursModal = () => {
  const { t } = useTranslation();
  return (
    <PaperBlock xs={12} margin={0} padding="0">
      <Block padding={4} paddingBottom={10}>
        <MediumText marginLeft={3}>{t('ONBOARD.selectWorkingDays')}</MediumText>
        <SmallGrayText marginLeft={3}>{t('ONBOARD.selectWorkingDaysHours')}</SmallGrayText>
        <OnboardWorkingHours />
      </Block>
    </PaperBlock>
  );
};

export default WorkingHoursModal;
